import axios from 'axios';


export async function getLocations({ coords,
                                     numberOfGuests,
                                     onSuccess,
                                     ownCatering,
                                     page,
                                     selectedSuitableKinds,
                                     selectedPrice,
                                     selectedTypes,
                                     selectedFacilities,
                                     selectedRegion,
                                     selectedDistrict,
                                   }) {

  let url = `/api/frontend/places.json`;
  const queryParams = [];
  const priceMin = 0;
  const priceMax = 500;
  const coordsPresent = coords && Object.keys(coords).length;

  // --------------------------------------------------------------------------------------------------------  PAGE -->>

  if (page) {
    queryParams.push(`page=${page}`);
  }

  // --------------------------------------------------------------------------------------------  NUMBER OF GUESTS -->>

  if (numberOfGuests) {
    queryParams.push(`guest_capacity=${numberOfGuests}`);
  }

  // --------------------------------------------------------------------------------------------------  PRICE FROM -->>

  if (selectedPrice && selectedPrice.min && selectedPrice.min !== priceMin) {
    queryParams.push(`price_per_seat_from=${selectedPrice.min}`);
  }

  // ----------------------------------------------------------------------------------------------------  PRICE TO -->>

  if (selectedPrice && selectedPrice.max && selectedPrice.max !== priceMax) {
    queryParams.push(`price_per_seat_to=${selectedPrice.max}`);
  }

  // ------------------------------------------------------------------------------------------  SUITABLE FOR KINDS -->>

  if (selectedSuitableKinds && selectedSuitableKinds.length > 0) {
    const suitableString = selectedSuitableKinds.join(',');
    queryParams.push(`suitable_for_kinds=${suitableString}`);
  }

  // -------------------------------------------------------------------------------------------------------  TYPES -->>

  if (selectedTypes && selectedTypes.length > 0) {
    const selectedTypesString = selectedTypes.join(',');
    queryParams.push(`categories=${selectedTypesString}`);
  }

  // --------------------------------------------------------------------------------------------------  FACILITIES -->>

  if (selectedFacilities && selectedFacilities.length > 0) {
    const selectedFacilitiesString = selectedFacilities.join(',');
    queryParams.push(`facilities=${selectedFacilitiesString}`);
  }

  // ------------------------------------------------------------------------------------------------  POSTAL CODES -->>

  // if (!coordsPresent && selectedPostalCodes && selectedPostalCodes.length > 0) {
  //   const selectedPostalCodesString = selectedPostalCodes.join(',');
  //   queryParams.push(`postal_codes=${selectedPostalCodesString}`);
  // }

  // ----------------------------------------------------------------------------------------------------  DISTRICT -->>

  if (!coordsPresent && selectedDistrict) {
    queryParams.push(`district=${selectedDistrict}`);
  }

  // ------------------------------------------------------------------------------------------------------  REGION -->>

  if (!coordsPresent && !selectedDistrict && selectedRegion) {
    queryParams.push(`region=${selectedRegion}`);
  }

  // -------------------------------------------------------------------------------------------------  COORDINATES -->>

  if (coords && Object.keys(coords).length) {
    const { sw_corner_latitude, sw_corner_longitude, ne_corner_latitude, ne_corner_longitude } = coords;

    queryParams.push(`sw_corner_latitude=${sw_corner_latitude}`);
    queryParams.push(`sw_corner_longitude=${sw_corner_longitude}`);
    queryParams.push(`ne_corner_latitude=${ne_corner_latitude}`);
    queryParams.push(`ne_corner_longitude=${ne_corner_longitude}`);
  };

  // ------------------------------------------------------------------------------------------------  OWN CATERING -->>

  if (ownCatering) {
    queryParams.push('permits_own_catering=true');
  };

  // ================================================================================================================>>>


  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.get(url);

    onSuccess(response.data.meta.total || 0);

    return response.data
  } catch (error) {
    console.error(error);
  }
}


export async function getMarkers({ coords,
                                   numberOfGuests,
                                   onSuccess,
                                   ownCatering,
                                   selectedFacilities,
                                   selectedPrice,
                                   selectedSuitableKinds,
                                   selectedTypes,
                                   selectedRegion,
                                   selectedDistrict,
                                 }) {


  let url = `/api/frontend/places/markers.json`;
  const queryParams = [];
  const priceMin = 0;
  const priceMax = 500;
  const coordsPresent = coords && Object.keys(coords).length;

  queryParams.push(`per_page=${3000}`);

  // --------------------------------------------------------------------------------------------  NUMBER OF GUESTS -->>

  if (numberOfGuests) {
    queryParams.push(`guest_capacity=${numberOfGuests}`);
  };

  // --------------------------------------------------------------------------------------------------  PRICE FROM -->>

  if (selectedPrice && selectedPrice.min && selectedPrice.min !== priceMin) {
    queryParams.push(`price_per_seat_from=${selectedPrice.min}`);
  };

  // ----------------------------------------------------------------------------------------------------  PRICE TO -->>

  if (selectedPrice && selectedPrice.max && selectedPrice.max !== priceMax) {
    queryParams.push(`price_per_seat_to=${selectedPrice.max}`);
  };

  // ------------------------------------------------------------------------------------------  SUITABLE FOR KINDS -->>

  if (selectedSuitableKinds && selectedSuitableKinds.length > 0) {
    const suitableString = selectedSuitableKinds.join(',');
    queryParams.push(`suitable_for_kinds=${suitableString}`);
  };

  // -------------------------------------------------------------------------------------------------------  TYPES -->>

  if (selectedTypes && selectedTypes.length > 0) {
    const selectedTypesString = selectedTypes.join(',');
    queryParams.push(`categories=${selectedTypesString}`);
  };

  // --------------------------------------------------------------------------------------------------  FACILITIES -->>

  if (selectedFacilities && selectedFacilities.length > 0) {
    const selectedFacilitiesString = selectedFacilities.join(',');
    queryParams.push(`facilities=${selectedFacilitiesString}`);
  };

  // ------------------------------------------------------------------------------------------------  POSTAL CODES -->>

  // if (!coordsPresent && selectedPostalCodes && selectedPostalCodes.length > 0) {
  //   const selectedPostalCodesString = selectedPostalCodes.join(',');
  //   queryParams.push(`postal_codes=${selectedPostalCodesString}`);
  // };

  // ----------------------------------------------------------------------------------------------------  DISTRICT -->>

  if (!coordsPresent && selectedDistrict) {
    queryParams.push(`district=${selectedDistrict}`);
  }

  // ------------------------------------------------------------------------------------------------------  REGION -->>

  if (!coordsPresent && !selectedDistrict && selectedRegion) {
    queryParams.push(`region=${selectedRegion}`);
  }

  // -------------------------------------------------------------------------------------------------  COORDINATES -->>

  if (coordsPresent) {
    const { sw_corner_latitude, sw_corner_longitude, ne_corner_latitude, ne_corner_longitude } = coords;

    queryParams.push(`sw_corner_latitude=${sw_corner_latitude}`);
    queryParams.push(`sw_corner_longitude=${sw_corner_longitude}`);
    queryParams.push(`ne_corner_latitude=${ne_corner_latitude}`);
    queryParams.push(`ne_corner_longitude=${ne_corner_longitude}`);
  };

  // ------------------------------------------------------------------------------------------------  OWN CATERING -->>

  if (ownCatering) {
    queryParams.push('permits_own_catering=true');
  };

  // ================================================================================================================>>>

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  };

  try {
    const response = await axios.get(url);

    !coordsPresent && onSuccess && onSuccess();

    return response.data
  } catch (error) {
    console.error(error);
  }
}
